import React from "react";
import NARB from "../assets/rosoftsavvy.png";
export default function Logo() {
  return <img src={NARB} alt='RSS Logo' width={30} height={"auto"} />;
}
